module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/modules/development/demo-component/demo-component.component.css
// module id = ./src/app/shared/modules/development/demo-component/demo-component.component.css
// module chunks = main